var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "reset-oa-box" }, [
    _c(
      "div",
      { staticClass: "input_box" },
      [
        _c("span", { staticClass: "lable" }, [_vm._v("*")]),
        _vm._v(" "),
        _c("span", { staticClass: "label-txt" }, [_vm._v("单据编号：")]),
        _vm._v(" "),
        _c("Input", {
          staticClass: "ref_input",
          attrs: { placeholder: "请输入单据编号" },
          model: {
            value: _vm.inputValue,
            callback: function ($$v) {
              _vm.inputValue = $$v
            },
            expression: "inputValue",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pop-btn" },
      [
        _c("Button", { staticClass: "cancel-btn", on: { click: _vm.cancel } }, [
          _c("span", [_vm._v(_vm._s(_vm.chineseName.CANCEL))]),
        ]),
        _vm._v(" "),
        _c(
          "Button",
          {
            staticClass: "sav-btn",
            attrs: { type: "error" },
            on: { click: _vm.save },
          },
          [_c("span", [_vm._v(_vm._s(_vm.chineseName.CONFIRM))])]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }